module.exports = __webpack_public_path__ + "static/media/play.9d407108.svg";